module.exports = __webpack_public_path__ + "static/img/Asset 2.bc82479.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Asset 2.png
// module id = 752
// module chunks = 0